<template>
  <div class="text-center mx-5 md:mx-auto my-8 max-w-[1200px]">
    <h2 class="text-ROJO_LEON my-6 flex justify-center items-start font-bold text-lg md:text-2xl">
      ¿CÓMO FUNCIONA NUESTRA<br class="md:hidden" />
      COMPRA ONLINE?
    </h2>
    <div class="md:grid md:grid-cols-3 text-center m-auto gap-5 my-8" :class="{ hidden: isSmallScreen }">
      <div v-for="(step, index) in data.steps" :key="index" :id="'slide-' + (index + 1)"
        class="px-[35px] relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 group hover:bg-ROJO_LEON transition-colors duration-300">
        <span
          class="hidden md:flex text-white h-[40px] w-[40px] rounded-full bg-ROJO_LEON absolute mt-[-20px] ml-[-25px] group-hover:bg-GRIS_LEON transition duration-300 items-center justify-center"
          :data-target="'slide-' + (index + 1)">
          {{ index + 1 }}
        </span>
        <span v-if="index + 1 < data.steps.length"
          class="hidden md:inline-flex justify-center items-center w-8 h-8 rounded-full absolute -right-7 top-1/2 -translate-y-1/2">
          <img class="w-40" :src="'/img/home/battery/arrow.svg'" alt="arrow-solid-right" />
        </span>
        <img :class="[
          'mx-auto transition duration-300 group-hover:invert group-hover:brightness-0',
          step.style,
        ]" :src="step.icon" :alt="step.title + '-icon'" />
        <h3 class="font-bold m-3 text-ROJO_LEON mt-6 group-hover:text-white transition duration-300">
          {{ step.title }}
        </h3>
        <p class="group-hover:text-white transition duration-300 text-start">
          {{ step.description }}
        </p>
      </div>
    </div>

    <div class="my-8" v-if="isSmallScreen">
      <div v-for="(step, index) in data.steps" :key="index" v-show="currentSlider === 'slide-' + (index + 1)"
        class="px-[1rem] relative rounded-md border border-GRIS_CLARO_BUSCAR_NEUMATICOS shadow-xl mx-auto py-8 transition-all duration-300">
        <img :class="['mx-auto', step.style]" :src="step.icon" :alt="step.title + '-icon'" />
        <h3 class="font-bold m-3 text-ROJO_LEON mt-6">
          {{ step.title }}
        </h3>
        <p class="text-start">
          {{ step.description }}
        </p>
      </div>
      <div class="my-4 grid grid-cols-3 gap-2 w-60 mx-auto">
        <button v-for="(step, index) in data.steps" :key="index" :class="currentSlider === 'slide-' + (index + 1)
          ? 'bg-ROJO_LEON'
          : 'bg-GRIS_LEON'
          " @click="showSlider('slide-' + (index + 1))" class="text-white text-xl h-[40px] w-[40px] rounded-full"
          :data-target="'slide-' + (index + 1)">
          {{ index + 1 }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const currentSlider = ref("slide-1");

const showSlider = (sliderId) => {
  currentSlider.value = sliderId;
};

const isSmallScreen = ref(false);

const handleResize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const data = {
  icon: "/img/shared/point-arrow-icon.webp",
  steps: [
    {
      title: "BUSCA TU BATERÍA",
      description:
        "Al iniciar tu compra, te pedimos que nos indiques la naturaleza de tu necesidad. ¿Requieres un rescate de emergencia para tu batería descargada, una instalación a domicilio por comodidad o prefieres acudir a nuestro local para la instalación? Esta información nos ayudará a preparar la mejor opción para ti.",
      icon: "/img/home/battery/busca-tu-bateria-icon.svg",
      style: "w-30",
    },
    {
      title: "SELECCIONA TU BATERÍA",
      description:
        "Facilítanos información sobre tu vehículo y tu ubicación para que podamos sugerirte las mejores alternativas de baterías disponibles y el local más cercano donde podremos atenderte o donde debes dirigirte para la instalación.",
      icon: "/img/home/battery/selecciona-tu-bateria-icon.svg",
      style: "w-30 mt-3",
    },
    {
      title: "MODALIDAD DE ATENCIÓN",
      description:
        "Define una fecha y hora que te convenga para recibir nuestro servicio. Si optas por la instalación en nuestro local, puedes decidir si prefieres agendar una cita o pagar directamente en la tienda. Para la instalación a domicilio, solo ofrecemos la opción de pago online para dejar agendado el servicio. Es importante mencionar que, en caso de una emergencia, toda esta coordinación se realizará vía telefónica para brindarte una solución rápida y efectiva a tu urgencia.",
      icon: "/img/home/battery/elige-la-modalidad-que-mas-te-acomoda-icon.svg",
      style: "w-30 -mb-3",
    },
  ],
};
</script>
